export function Event (data) {
  format(data)
  this.id = data.id
  this.title = data.title
  this.urlTitle = eventUrl(data.id, data.title)
  this.description = data.description
  this.htmlDescription = data.htmlDescription
  this.date = data.date instanceof Date ? data.date : getDate(data.date)
  this.endDate = data.endDate instanceof Date ? data.endDate : getDate(data.endDate)
  this.photoUrl = data.photoUrl
  this.price = data.price
  this.donation = data.donation
  this.minDonation = data.minDonation
  this.venue = data.venue
  this.address = data.address
  this.city = data.city
  this.zipCode = data.zipCode
  this.capacity = data.capacity
  this.numRegistered = data.numRegistered
  this.tags = data.tags
  this.registeredUsers = data.registeredUsers
  this.interestedUsers = data.interestedUsers
  this.donationAmounts = data.donationAmounts
  this.checkedInUsers = data.checkedInUsers

  this.isPast = () => {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return this.date < today
  }
  this.isUpcoming = () => !this.isPast()
}

function format (data) {
  // Convert properties from backend with snake_case names to camelCase names
  const snakeCaseKeys = [
    ['html_description', 'htmlDescription'],
    ['end_date', 'endDate'],
    ['photo_url', 'photoUrl'],
    ['min_donation', 'minDonation'],
    ['zip_code', 'zipCode'],
    ['total_signups', 'numRegistered'],
    ['registered_users', 'registeredUsers'],
    ['interested_users', 'interestedUsers'],
    ['donation_amounts', 'donationAmounts'],
    ['checked_in_users', 'checkedInUsers']
  ]

  for (let [backendKey, formattedKey] of snakeCaseKeys) {
    if (data.hasOwnProperty(backendKey) && !data.hasOwnProperty(formattedKey)) {
      data[formattedKey] = data[backendKey]
    }
  }
}

function getDate (dateString) {
  // Convert YYMMDDHHMM to UTC Date object
  if (!dateString || dateString.length !== 10) return ''

  const [
    year,
    month,
    date,
    hour,
    minute
  ] = [
    '20' + dateString.substr(0, 2),
    dateString.substr(2, 2) - 1,
    dateString.substr(4, 2),
    dateString.substr(6, 2),
    dateString.substr(8, 2)
  ]

  return new Date(year, month, date, hour, minute)
}

// Maps titles to integers signifying how many events with that title there
// are (eg {'my-event': 2} means /my-event and /my-event-2 are taken.
// Also maps event ids to their already calculated title for caching
// (eg: {'-Lxisd0fwe...': 'my-event-2'})
const urlTitleCache = {}

function eventUrl (eventId, eventTitle) {
  // Lower case title, remove apostrophes, strip all non a-z0-9 characters, split on white space, join with '-'
  // There can obviously be collisions here, with cases or punctuation
  // My Event -> my-event
  // My EveNt! -> my-event
  // my  event !!? -> my-event
  if (urlTitleCache[eventId] === undefined) {
    let urlTitle = (eventTitle || '').toLowerCase()
      .split(/'/g).join('')
      .split(/[^0-9a-z]/gi)
      .filter(word => word.length > 0)
      .join('-')

    if (urlTitleCache[urlTitle] !== undefined) {
      urlTitleCache[urlTitle] += 1
      urlTitle += '-' + urlTitleCache[urlTitle]
    } else {
      urlTitleCache[urlTitle] = 1
    }

    urlTitleCache[eventId] = urlTitle
  }

  return urlTitleCache[eventId]
}
